import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Gist from "react-gist";
const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Openscad = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">OpenScad</Typography>
      <Typography className={classes.para} paragraph>
        I downloaded OpenScad from{" "}
        <Link href={"http://www.openscad.org/"}>openscad.org</Link>. OpenScad is
        the 'Programmers Solid 3D CAD Modeller'. It is unitless. Like any
        programming language it has variables, functions, modules, prebuilt
        libraries.
      </Typography>
      <Typography variant="h5">STL</Typography>
      <Typography className={classes.para} paragraph>
        STL stands for "Standard Triangle Language". STL files contain no scale
        information, and the units are arbitrary. STL files describe only the
        surface geometry of a three-dimensional object without any
        representation of color, texture or other common CAD model attributes.
        It is widely used for rapid prototyping and 3D printing.
        <br /> OpenScad primarily exports 3D files in this format.
      </Typography>
      <Typography variant="h5">Animate with OpenScad</Typography>
      <Typography className={classes.para} paragraph>
        <Gist
          id="5137cc6cd9a8966eac8fea758ea4e8f8"
          file="animate-sphere.scad"
        />
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./openscad/openscad.gif"
            alt="gimp"
          />{" "}
          <br />
          $t would take on the values from 0 to 1. It is a special variable of
          openscad. I've assigned $t to counter of loops. The animation is
          activated from View > Animate. It requires two additional input namely
          FPS and Steps. FPS sets the 'frames per second', and steps add
          (1/step) sec to $t for each step.
        </div>{" "}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Openscad);
